import httpClient from "../http/http-client";
import { IAnalyticReport, IAnalyticReportWithEmissionsAndFilters, IAnalyticReportWithFilters, IPostAnalyticReport } from './analytic-report.model';

export default class AnalyticReportService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<IAnalyticReport[]> {
    return this.http.get(`analytic-report${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(reportId: string): Promise<IAnalyticReport> {
    return this.http.get(`analytic-report/${reportId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOneWithFilters(reportId: string): Promise<IAnalyticReportWithFilters> {
    return this.http.get(`analytic-report/${reportId}?includeFilters=true`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async getOneWithFiltersAndEmissionsPagination(reportId: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', excludeExcludedFromReporting?: boolean): Promise<IAnalyticReportWithEmissionsAndFilters> {
    return this.http.get(`analytic-report/${reportId}?includeEmissions=true&includeCharts=true&includeFilters=true&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${excludeExcludedFromReporting ? '&excludeExcludedFromReporting=true' : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async create(report: IPostAnalyticReport): Promise<IAnalyticReport> {
    return this.http.post(`analytic-report`, report)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(reportId: string, report: IPostAnalyticReport): Promise<IAnalyticReport> {
    return this.http.patch(`analytic-report/${reportId}`, report)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async remove(reportId: string): Promise<IAnalyticReport> {
    return this.http.delete(`analytic-report/${reportId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async send(reportId: string, payload: { distributionListIds: string[], additionalEmails: string[], customEmailText?: string }): Promise<{ queued: number, s3Key: string }> {
    return this.http.post(`analytic-report/${reportId}/send`, payload)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}